import * as z from 'zod'

export const faqSchema = z.object({
  categoryId: z.number(),
  categoryName: z.string(),
  questions: z
    .object({
      answer: z.string(),
      name: z.string(),
      slug: z.string(),
    })
    .array(),
})

export type Faq = z.infer<typeof faqSchema>

export const faqStandaloneSchema = z.object({
  answer: z.string(),
  description: z.string(),
  question: z.string(),
})

export type FaqStandalone = z.infer<typeof faqStandaloneSchema>
